module.exports = __webpack_public_path__ + "amazon.logo.4ffaf.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/logo/amazon.logo.svg
// module id = 3553
// module chunks = 0